/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FilterConditionGroupDto } from './FilterConditionGroupDto';
import type { NotificationRuleAssetSelectionDto } from './NotificationRuleAssetSelectionDto';

export type NotificationRuleAssetDynamicSelectionDto = (NotificationRuleAssetSelectionDto & {
    conditionGroups?: Array<FilterConditionGroupDto>;
    logicalOperator?: NotificationRuleAssetDynamicSelectionDto.logicalOperator;
} & {
    conditionGroups: Array<FilterConditionGroupDto>;
    logicalOperator: NotificationRuleAssetDynamicSelectionDto.logicalOperator;
});

export namespace NotificationRuleAssetDynamicSelectionDto {

    export enum logicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
